<template>
  <div class="product-search">
    <input type="text" class="input input--productsearch" placeholder="Product search" v-model="productFilter">
    <select class="select select--category" v-model="productCategory">
      <option :value="-1">All Categories</option>
      <option :value="category.Id" v-for="category in productCategories">{{category.Name}}</option>
    </select>
  </div>
  <ul class="tabs tabs--products">
    <li class="tabs__item" :class="{'tabs__item--active': category.Id == selectedCategory}" v-for="category in products" @click="selectCategory($index)">{{category.Name}}</li>
  </ul>
  <div class="products-categories-list" v-for="category in products" v-if="category.Id == selectedCategory">
    <products-list-category :productfilter="productFilter" :content="item" v-for="item in category.Items" v-if="productCategory === -1 || productCategory === item.Id"></products-list-category>
  </div>
</template>

<script>
import ProductsListCategory from "./ProductsListCategory";

export default {
  data: function () {
    return {
      selectedCategory: -1,
      productCategories: [],
      productCategory: -1,
      productFilter: ""
    };
  },
  components: {
    ProductsListCategory
  },
  methods: {
    selectCategory (index) {
      if (!this.products.length) {
        return;
      }
      this.selectedCategory = this.products[index].Id;
      this.productCategories = this.products[index].Items;
    }
  },
  vuex: {
    getters: {
      products: state => state.products
    }
  },
  ready: function () {
    this.selectCategory(0);
  },
  watch: {
    "products": function (value) {
      this.selectCategory(0);
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .product-search{
    float: right;
    margin-top: -70px;
  }

  .input--productsearch{
    margin-left: 0px;
    border-radius: 3px 0 0 3px;
    border: 1px solid $green_dark;
    margin-right: -5px;
    width: 270px;
  }
  .select--category{
    width: 180px;
    display: inline-block;
    border-radius: 0 3px 3px 0;
  }
</style>


// WEBPACK FOOTER //
// ProductsList.vue?f5d76c62